import { render, staticRenderFns } from "./SectorAdd.vue?vue&type=template&id=c7e29586&scoped=true"
import script from "./SectorAdd.vue?vue&type=script&lang=js"
export * from "./SectorAdd.vue?vue&type=script&lang=js"
import style0 from "./SectorAdd.vue?vue&type=style&index=0&id=c7e29586&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e29586",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7e29586')) {
      api.createRecord('c7e29586', component.options)
    } else {
      api.reload('c7e29586', component.options)
    }
    module.hot.accept("./SectorAdd.vue?vue&type=template&id=c7e29586&scoped=true", function () {
      api.rerender('c7e29586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/SectorAdd.vue"
export default component.exports